/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Classes, Elevation, InputGroup, Intent } from '@blueprintjs/core';
import LoadingIcon from 'components/loadingIcon';

/**
 * A standard Serberus authentication dialog.
 *
 * @param title
 * @param authenticate
 * @param isAuthenticated
 * @param error
 * @returns {null|*}
 * @constructor
 */
export const Login = ({ title = 'Log In', authenticate, isAuthenticated, error }) => {
	const [userName, setUserName] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoadingStatus] = useState(false);

	const onKeyDown = (event) => {
		if (event.keyCode === 13) {
			onClick();
		}
	};

	const onClick = () => {
		setLoadingStatus(true);
		if (userName && password) {
			authenticate(userName, password);
			setPassword('');
		}
	};

	// TODO: Add background blur/deblur

	if (isAuthenticated) return null;

	return (
		<Card elevation={Elevation.THREE} css={card}>
			<center>
				<h4 className="bp3-heading">{title}</h4>
			</center>
			{error && (
				<center>
					<p className="bp3-non-ideal-state">{getErrorMessage(error)}</p>
				</center>
			)}
			<br></br>
			<InputGroup
				cy-test="username"
				className={Classes.FILL}
				leftIcon="user"
				onKeyDown={onKeyDown}
				onChange={(event) => setUserName(event.target.value)}
				name="username"
				placeholder="Username"
				value={userName}
				autoFocus
			/>
			<InputGroup
				cy-test="password"
				className={Classes.FILL}
				leftIcon="lock"
				type="password"
				name="password"
				placeholder="Password"
				onKeyDown={onKeyDown}
				onChange={(event) => setPassword(event.target.value)}
				value={password}
			/>
			<Button
				cy-test="login-btn"
				onClick={onClick}
				disabled={!userName || !password}
				intent={Intent.PRIMARY}
				fill={true}
			>
				Log In
			</Button>
			<br></br>
			<br></br>
			<br></br>

			{loading === true && !error && <LoadingIcon />}
		</Card>
	);
};

const card = css`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 400px;
	height: 220px;
	margin: auto;

	div {
		margin-bottom: 10px;
	}
`;

var getErrorMessage = (error) => {
	if (error.message === 'Failed to fetch') {
		return 'Server Connection Error';
	} else if (error.message === 'Unauthorized') {
		return 'Invalid Username/Password';
	} else {
		return error.message;
	}
};

Login.propTypes = {
	error: PropTypes.any,
	isAuthenticated: PropTypes.bool,
	authenticate: PropTypes.func,
};
